import { forwardRef, useImperativeHandle, useRef } from 'react';
import GWPInput, { GWPInputProps } from './GWPInput';

export interface GWPSearchInputProps
	extends Omit<GWPInputProps, 'type' | 'startAdornment' | 'endAdornment' | 'onValueChange'> {
	value: string;
	onValueChange: (value: string, event?: React.ChangeEvent<HTMLInputElement>) => void;
	clearButtonLabel?: string;
}

const GWPSearchInput = forwardRef<HTMLInputElement, GWPSearchInputProps>((props, ref) => {
	const { className, value, onValueChange, clearButtonLabel = 'Clear search', disabled, readOnly, ...rest } = props;
	const inputRef = useRef<HTMLInputElement>(null);

	useImperativeHandle(ref, () => inputRef.current as HTMLInputElement);

	const clearButton =
		value && !disabled && !readOnly ? (
			<button
				type="button"
				className="gwp-search-input-clear"
				onClick={() => {
					onValueChange('');
					inputRef.current?.focus({ preventScroll: true });
				}}
				aria-label={clearButtonLabel}
				title={clearButtonLabel}
			>
				<i className="fas fa-times" aria-hidden="true" />
			</button>
		) : undefined;

	return (
		<GWPInput
			{...rest}
			ref={inputRef}
			className={`gwp-search-input${className ? ` ${className}` : ''}`}
			type="search"
			value={value}
			disabled={disabled}
			readOnly={readOnly}
			startAdornment={<i className="fas fa-search" aria-hidden="true" />}
			endAdornment={clearButton}
			onValueChange={onValueChange}
		/>
	);
});

GWPSearchInput.displayName = 'GWPSearchInput';

export default GWPSearchInput;
